/* eslint-disable no-nested-ternary */
import React from 'react'
import { Badge } from 'rsuite'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string
}

type TypeCellProps = {
  rowData?: RowData,
  dataKey: string
}

const defaultProps = {
  rowData: undefined
}

const depositLabels = ['DEPOSIT']
const withdrawalLabels = ['WITHDRAWAL']
const transferLabels = ['TRANSFER']

const depositStyle = {
  backgroundColor: '#E3FCEF',
  color: '#14BA6D',
  padding: '3px 10px 3px 5px'
}

const withdrawalStyle = {
  backgroundColor: '#FDEDED',
  color: '#D32F2F',
  padding: '3px 10px 3px 5px'
}

const transferStyle = {
  backgroundColor: '#FFF4E5',
  color: '#E67E22',
  padding: '3px 10px 3px 5px'
}

const TransactionTypeCell: React.FC<TypeCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const label = rowData?.[dataKey]?.toUpperCase() || ''

  const isDeposit = depositLabels.includes(label)
  const isWithdrawal = withdrawalLabels.includes(label)
  const isTransfer = transferLabels.includes(label)

  let typeStyle = transferStyle
  let typeText = 'DEDUCTION'

  if (isDeposit) {
    typeStyle = depositStyle
    typeText = 'Deposit'
  } else if (isWithdrawal) {
    typeStyle = withdrawalStyle
    typeText = 'Withdrawal'
  } else if (isTransfer) {
    typeStyle = transferStyle
    typeText = 'Transfer'
  }

  return (
    <Cell {...props}>
      <Badge
        style={typeStyle}
        content={
          <>
            <Badge
              style={{
                backgroundColor: isDeposit
                  ? '#14BA6D'
                  : isWithdrawal
                    ? '#D32F2F'
                    : '#E67E22',
                margin: '0 7px'
              }}
            />
            {typeText}
          </>
        }
      />
    </Cell>
  )
}

TransactionTypeCell.defaultProps = defaultProps

export default TransactionTypeCell
